import Vue from 'vue'
import i18n from '@/lang'
import Multiselect from 'vue-multiselect'

Vue.component('multiselect', {
  extends: Multiselect,
  props: {
    selectLabel: {
      type: String,
      default: i18n.t('common.multiselect.selectLabel')
    },
    selectedLabel: {
      type: String,
      default: i18n.t('common.multiselect.selectedLabel')
    },
    selectGroupLabel: {
      type: String,
      default: i18n.t('common.multiselect.selectGroupLabel')
    },
    deselectGroupLabel: {
      type: String,
      default: i18n.t('common.multiselect.deselectGroupLabel')
    },
    deselectLabel: {
      type: String,
      default: i18n.t('common.multiselect.deselectLabel')
    },
    placeholder: {
      type: String,
      default: i18n.t('common.multiselect.placeholder')
    }
  }
})
